<template>
  <div class="d-flex mt-2 sticky-box justify-center">
    <v-btn @click="changeOfferType()" large tile outlined class="link non-text-transformation">
      {{ btnLabel }}
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_OFFER_ITEM } from '@/store/modules/offer/getters'

export default {
  name: 'ChangeTypeButton',
  computed: {
    ...mapGetters('offer', [GET_OFFER_ITEM]),
    offerType() {
      return this[GET_OFFER_ITEM]('type')
    },
    btnLabel() {
      return this.offerType === 'C'
        ? this.$t('STICKYBOX_BUTTON_CONVERTA')
        : this.$t('STICKYBOX_BUTTON_CONVERTC')
    },
  },
  methods: {
    changeOfferType() {
      this.$emit('onChangeType')
    },
  },
}
</script>
